import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getClientApiKeys, getClientApiSearchSuggestions } from "../../../../Api/ClientApiManagementApi";
import CODE from "../../../../Static/Constants/StatusCodes";
import { SetSessionExpired } from "../../../../Actions";

const ROWS_PER_PAGE = 10;

const normalizeStatus = (val) => {
  const s = String(val ?? "").toLowerCase().trim();
  // Backend now sends the resolved status string directly.
  if (s === "expired" || s === "active" || s === "inactive") return s;
  // Fallback for any legacy boolean/truthy is_active value.
  if (val === null || val === undefined || val === false || val === 0) return "inactive";
  return s !== "false" && s !== "0" && s !== "" ? "active" : "inactive";
};

const transformRow = (row) => ({
  ...row,
  is_active: normalizeStatus(row.is_active),
});

export const useClientApiData = () => {
  const dispatch = useDispatch();
  const [allData, setAllData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [searchFilter, setSearchFilter] = useState({ devices: [], column: null });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    const res = await getClientApiKeys();
    if (res?.responseStatus?.code === CODE.SUCCESS) {
      setAllData((res.response?.data || []).map(transformRow));
    } else if (res?.responseStatus?.code === CODE.SESSION_EXPIRED) {
      dispatch(SetSessionExpired(true));
    }
    setIsLoading(false);
  };

  const filteredData =
    searchFilter.devices.length > 0 && searchFilter.column
      ? allData.filter((row) =>
          searchFilter.devices.some((d) =>
            String(row[searchFilter.column] ?? "")
              .toLowerCase()
              .includes(d.toLowerCase())
          )
        )
      : allData;

  const pagedData = filteredData.slice(
    (pageNumber - 1) * ROWS_PER_PAGE,
    pageNumber * ROWS_PER_PAGE
  );

  const applySearch = (devices, column) => {
    setSearchFilter({ devices, column });
    setPageNumber(1);
  };

  const searchSuggestionsHandler = (query) => {
    if (!query) return Promise.resolve({ responseStatus: { code: CODE.SUCCESS }, response: { data: [] } });
    return getClientApiSearchSuggestions(query);
  };

  return {
    pagedData,
    total: filteredData.length,
    isLoading,
    pageNumber,
    setPageNumber,
    applySearch,
    searchSuggestionsHandler,
  };
};
